package link.erpango.quip.data.remote.ktor

import io.ktor.client.request.HttpRequest
import io.ktor.client.request.HttpRequestBuilder
import io.ktor.client.request.setBody
import io.ktor.client.utils.EmptyContent
import io.ktor.content.TextContent
import io.ktor.http.ContentType
import io.ktor.http.HttpMethod
import io.ktor.http.encodedPath
import io.ktor.http.takeFrom
import kotlinx.serialization.KSerializer
import kotlinx.serialization.json.Json
import link.erpango.quip.data.remote.ApiClient

class RestConsumer(
    val api: ApiClient,
    resourcePath: String

): IRestConsumer {

    override val baseUrl get() = api.urlResolver.baseUrl
    override val resourcePath = resourcePath
    override val httpClient = api.httpClient
    override val httpHeaders = api.headers
    override var json = api.json

    constructor(
        api: ApiClient,
        resourcePath: String,
        altJson: Json
    ): this(api = api, resourcePath = resourcePath) {

        this.json = altJson
    }

    fun get(): IHttpRequest {

        return this.buildRequest(HttpMethod.Get, this.resourcePath, EmptyContent)
    }

    fun get(id:Int): IHttpRequest {

        return this.buildRequest(HttpMethod.Get, "${this.resourcePath}/$id", EmptyContent)
    }

    fun <T> post(body:T, serializable: KSerializer<T>): IHttpRequest {

        val requestBody = this.buildRequestBody(body, serializable)
        return this.buildRequest(HttpMethod.Post, this.resourcePath, requestBody)
    }

    fun put(): IHttpRequest {

        return this.buildRequest(HttpMethod.Put, resourcePath, EmptyContent)
    }

    fun <T> put(id: Int, body: T, serializable: KSerializer<T>): IHttpRequest {

        val requestBody = this.buildRequestBody(body, serializable)
        return this.buildRequest(HttpMethod.Put, "${this.resourcePath}/$id", requestBody)
    }

    fun <T> put(body: T, serializable: KSerializer<T>): IHttpRequest {

        val requestBody = this.buildRequestBody(body, serializable)
        return this.buildRequest(HttpMethod.Put, resourcePath, requestBody)
    }

    fun <T> patch(id: Int, body: T, serializable: KSerializer<T>): IHttpRequest {

        val requestBody = this.buildRequestBody(body, serializable)
        return this.buildRequest(HttpMethod.Patch, "${this.resourcePath}/$id", requestBody)
    }

    fun <T> patch(id: String, body: T, serializable: KSerializer<T>): IHttpRequest {

        val requestBody = this.buildRequestBody(body, serializable)
        return this.buildRequest(HttpMethod.Patch, "${this.resourcePath}/$id/", requestBody)
    }

    fun <T> patch(body: T, serializable: KSerializer<T>): IHttpRequest {

        val requestBody = this.buildRequestBody(body, serializable)
        return this.buildRequest(HttpMethod.Patch, resourcePath, requestBody)
    }

    fun <T> delete(body: T, serializable: KSerializer<T>): IHttpRequest {

        val requestBody = this.buildRequestBody(body, serializable)
        return this.buildRequest(HttpMethod.Delete, this.resourcePath, requestBody)
    }

    fun delete(id:Int): IHttpRequest {

        return this.buildRequest(HttpMethod.Delete, "${this.resourcePath}/$id/", EmptyContent)
    }

    private fun <T> buildRequestBody(body: T, serializable: KSerializer<T>): TextContent =

        TextContent(
            json.encodeToString(serializable, body),
            ContentType.Application.Json.withoutParameters()
        )

    private fun buildRequest(method: HttpMethod, path:String, body: Any): IHttpRequest {

        val builder = HttpRequestBuilder()
        builder.method = method
        builder.setBody(body)
        builder.url {
            takeFrom(baseUrl)
            encodedPath += path
        }
        with(builder.headers) {
            httpHeaders.map {
                append(it.key, it.value)
            }
        }

        return HttpRequest(
            this.httpClient,
            builder,
            this.json
        )
    }
}